import { Typography } from "@mui/material";
import cn from "classnames";
import "./IconCard.css";

const IconCard = (props) => {
    const {
        icon, title, children, className,
    } = props;

    return (
        <div className={cn("icon-card", className)}>
            <div className="icon-card__icon">
                {icon}
            </div>
            <div className="icon-card__content">
                {title && <Typography variant="h4" className="icon-card__title">{title}</Typography>}
                {children}
            </div>
        </div>
    );
};

export default IconCard;
